export default {
    user1 : [
        {
            'title' : 'Wyzwania',
            'route' : 'ChallangeIndex',
            'icon' : 'icon-chart'
        },{
            'title' : 'Wiedza',
            'route' : 'KnowledgeIndex',
            'icon' : 'icon-hat'
        },{
            'title' : 'Zadania specjalne',
            'route' : 'SpecialsIndex',
            'icon' : 'icon-diamond'
        },{
            'title' : 'Aktualności',
            'route' : 'NewsIndex',
            'icon' : 'icon-document'
        },{
            'title' : 'Strefa wiedzy',
            'route' : 'KnowledgeZoneList',
            'icon' : 'icon-book'
        },{
            'title' : 'Kalendarz',
            'route' : 'CalendarIndex',
            'icon' : 'icon-calendar'
        },{
            'title' : 'Nagrody',
            'route' : 'PrizesIndex',
            'icon' : 'icon-prize'
        },{
            'title' : 'Zasady',
            'route' : 'RulesIndex',
            'icon' : 'icon-weight'
        },{
            'title' : 'Regulamin',
            'route' : 'RegulationsIndex',
            'icon' : 'icon-document'
        },{
            'title' : 'Kontakt',
            'route' : 'ContactIndex',
            'icon' : 'icon-chat'
        }
    ],
    user2 : [
        {
            'title': 'Zadania specjalne',
            'route': 'SpecialsIndex',
            'icon': 'icon-diamond'
        },{
            'title' : 'Aktualności',
            'route' : 'NewsIndex',
            'icon' : 'icon-document'
      },{
        'title' : 'Strefa wiedzy',
        'route' : 'KnowledgeZoneList',
        'icon' : 'icon-book'
      },{
            'title' : 'Regulamin',
            'route' : 'RegulationsIndex',
            'icon' : 'icon-document'
        },{
            'title' : 'Kontakt',
            'route' : 'ContactIndex',
            'icon' : 'icon-chat'
        }
    ],
    user3 : [
        {
            'title' : 'Wyzwania',
            'route' : 'ChallangeIndex',
            'icon' : 'icon-chart'
        },{
            'title' : 'Wiedza',
            'route' : 'KnowledgeIndex',
            'icon' : 'icon-hat'
        },{
            'title' : 'Aktualności',
            'route' : 'NewsIndex',
            'icon' : 'icon-document'
      },{
        'title' : 'Strefa wiedzy',
        'route' : 'KnowledgeZoneList',
        'icon' : 'icon-book'
      },{
            'title' : 'Kalendarz',
            'route' : 'CalendarIndex',
            'icon' : 'icon-calendar'
        },{
            'title' : 'Nagrody',
            'route' : 'PrizesIndex',
            'icon' : 'icon-prize'
        },{
            'title' : 'Zasady',
            'route' : 'RulesIndex',
            'icon' : 'icon-weight'
        },{
            'title' : 'Regulamin',
            'route' : 'RegulationsIndex',
            'icon' : 'icon-document'
        },{
            'title' : 'Kontakt',
            'route' : 'ContactIndex',
            'icon' : 'icon-chat'
        }
    ],
    salesman : [
        {
            'title' : 'Raporty',
            'route' : 'ReportIndex',
            'icon' : 'icon-meter'
        },{
            'title' : 'Raporty Wiedzy',
            'route' : 'ReportKnowledgeIndex',
            'icon' : 'icon-hat'
        },{
            'title' : 'Raporty Zadań Specjalnych',
            'route' : 'ReportSpecialsIndex',
            'icon' : 'icon-diamond'
        },{
            'title': 'Zaproszenia',
            'route': 'InvitationsIndex',
            'icon': 'icon-envelope'
        },{
            'title' : 'Rozliczenia',
            'route' : 'BalancesIndex',
            'icon' : 'icon-calculator'
        },{
            'title' : 'Wiedza',
            'route' : 'KnowledgeIndex',
            'icon' : 'icon-hat'
        },{
            'title' : 'Strefa wiedzy',
            'route' : 'KnowledgeZoneList',
            'icon' : 'icon-book'
        },{
            'title' : 'Aktualności',
            'route' : 'NewsIndex',
            'icon' : 'icon-document'
        },{
            'title' : 'Kalendarz',
            'route' : 'CalendarIndex',
            'icon' : 'icon-calendar'
        },{
            'title' : 'Nagrody',
            'route' : 'PrizesIndex',
            'icon' : 'icon-prize'
        },{
            'title' : 'Zasady',
            'route' : 'RulesIndex',
            'icon' : 'icon-weight'
        },{
            'title' : 'Regulamin',
            'route' : 'RegulationsIndex',
            'icon' : 'icon-document'
        },{
            'title' : 'Kontakt',
            'route' : 'ContactIndex',
            'icon' : 'icon-chat'
        }
    ]
}
